import SessionList from '../../components/SessionList'
import { actions as sessionActions } from '../../redux/modules/sessions'
// import config from '../../config'

class MindSessionsList extends SessionList {
  constructor (props) {
    super(props)
    this.state.pageType = 'meTime'
  }

  getTexts = () => {
    return {
      tableTitle: 'Mind Sessions',
      searchTitle: 'Search Session'
    }
  }

  getList = async () => {
    const list = await sessionActions.getMeTimeSessionsList('mind')
    return list
  }

  getEditRoute = () => {
    return '/session-metime-edit'
  }
}

export default MindSessionsList
